import { createVuetify } from "vuetify";
import { aliases, mdi } from "vuetify/iconsets/mdi-svg";

export default defineNuxtPlugin((nuxtApp) => {
  const vuetify = createVuetify({
    icons: {
      defaultSet: "mdi",
      aliases,
      sets: { mdi },
    },
    theme: {
      defaultTheme: "light",
      themes: {
        light: {
          dark: false,
          colors: {
            primary: "#033128",
            primary40: "#d9e0df",
            accent: "#d9e0df",
            secondary: "#68bea6",
            warning: "#e0c301",
            error: "#d34d2a",
            success: "#d2ffaa",
          },
          variables: {
            "disabled-opacity": 1,
          },
        },
      },
    },
  });
  nuxtApp.vueApp.use(vuetify);
});
